export default {
  state: {
    position: {},
    isKnown: false,
    message: '',
    error: null,
    positionOptions: {
      enableHighAccuracy: true,
      maximumAge: 30000,
      timeout: 3000
    },
    watchId: null
  },
  getters: {
    lat: (state) => {
      if (state.isKnown && state.position.coords.latitude) {
        return state.position.coords.latitude.toFixed(4)
      } else {
        return null
      }
    },
    long: (state) => {
      if (state.isKnown && state.position.coords.longitude) {
        return state.position.coords.longitude.toFixed(4)
      } else {
        return null
      }
    },
    accuracy: (state) => {
      if (state.isKnown && state.position.coords.accuracy) {
        return state.position.coords.accuracy.toFixed(0).toString() + ' m'
      } else {
        return null
      }
    },
    speed: (state) => {
      if (state.isKnown && state.position.coords.speed) {
        return (state.position.coords.speed / 1000 * 60 * 60).toFixed(2).toString() + ' km/h'
      } else {
        return null
      }
    },
    altitude: (state) => {
      if (state.position.isKnown && state.position.coords.altitude) {
        return state.position.coords.altitude.toFixed(2).toString() + ' m'
      } else {
        return null
      }
    },
    altitudeAccuracy: (state) => {
      if (state.isKnown && state.position.coords.altitudeAccuracy) {
        return state.position.coords.altitudeAccuracy.toFixed(0).toString() + ' m'
      } else {
        return null
      }
    },
    heading: (state) => {
      if (state.isKnown && state.position.coords.heading) {
        return state.position.coords.heading.toFixed(2).toString() + ' \xB0'
      } else {
        return null
      }
    }
  },
  mutations: {
    updateSuccess (state, payload) {
      console.log('Mutation: userPosition/updateSuccess')
      state.position = payload
      state.isKnown = true
      state.message = ''
    },
    updateFailed (state, error) {
      console.log('Mutation: userPosition/updateFailed')
      // Do not blank out previous position on failed update to try and avoid
      // timeout error resulting in nothing displaying. Hopefully this will
      // display previous items on NearestView until a new update succeeds
      // Relates to #86
      // state.position = {}
      state.isKnown = false
      state.message = 'Position update failed.'
      state.error = error
    },
    notSupported (state) {
      console.log('Mutation: userPosition/notSupported')
      state.position = {}
      state.isKnown = false
      state.message = 'Geolocation not supported or not enabled.'
    },
    updateWatchId (state, payload) {
      console.log('Mutation: userPosition/updateWatchId')
      state.watchId = payload
    },
    positionNotKnown (state) {
      console.log('Mutation: userPosition/positionNotKnown')
      state.isKnown = false
    }
  },
  actions: {
    trackPosition (context) {
      console.log('Action: userPosition/trackPosition')
      if (navigator.geolocation) {
        const watchId = navigator.geolocation.watchPosition(
          // Success
          (payload) => {
            context.commit('updateSuccess', payload)
          },
          // Failed
          (error) => {
            context.commit('updateFailed', error)
            if (context.state.watchId) {
              console.log('ERROR(' + error.code + '): ' + error.message)
            }
          },
          // Options
          context.state.positionOptions)
        context.commit('updateWatchId', watchId)
      } else {
        context.commit('notSupported')
      }
    },
    endTrackPosition (context) {
      console.log('Action: userPosition/endTrackPosition')
      navigator.geolocation.clearWatch(context.state.watchID)
      context.commit('updateWatchId', null)
      context.commit('positionNotKnown')
    }
  },
  namespaced: true
}
